import React from 'react'

const Erorr404Page = () => {
  return (
    <div>Erorr404Page</div>
  )
}

export default Erorr404Page